import { useMemo } from 'react'
import { groupBy, identity, filter, prop, __ } from 'ramda'

import { useReportsEnabled } from 'app/dataProviders/reports/hooks'

import { reportsArrange } from './availableReports'

export function useCommonReportsEnabled() {
  const { reportsEnabled, loading } = useReportsEnabled()

  const enabledArranged = useMemo(() => {
    const enabledByKey = groupBy(identity, reportsEnabled)
    // @ts-ignore
    return filter(prop(__, enabledByKey), reportsArrange)
  }, [reportsEnabled])

  return { reportsEnabled: enabledArranged, loading }
}
